import { gql } from '@apollo/client';

export const ProductListingFragment = gql`
  fragment ProductListingFragment on Cart {
    id
    # eslint-disable-next-line @graphql-eslint/require-id-when-available
    items {
      uid
      # eslint-disable-next-line @graphql-eslint/require-id-when-available
      select_product_image
      category_name
      product {
        uid
        name
        serial_name
        sku
        url_key
        serial_name
        stock_status
        thumbnail {
          url
        }
        small_image {
          url
        }
        presale_product {
          status
          label
          note
        }
        stock_status
        price_range {
          maximum_price {
            final_price {
              currency
              value
            }
            regular_price {
              currency
              value
            }
          }
          minimum_price {
            final_price {
              currency
              value
            }
            regular_price {
              currency
              value
            }
            discount {
              amount_off
            }
          }
        }
        # eslint-disable-next-line @graphql-eslint/require-id-when-available
        ... on ConfigurableProduct {
          variants {
            attributes {
              uid
              code
              value_index
            }
            # eslint-disable-next-line @graphql-eslint/require-id-when-available
            product {
              presale_product {
                status
                label
                note
              }
              sku
              stock_status
              uid
              small_image {
                url
              }
            }
          }
        }
        ... on ConfigurableProduct {
          configurable_options {
            attribute_code
            attribute_id
            uid
            label
            # eslint-disable-next-line @graphql-eslint/require-id-when-available
            values {
              uid
              default_label
              label
              store_label
              use_default_value
              value_index
              swatch_data {
                ... on ImageSwatchData {
                  thumbnail
                }
                value
              }
            }
          }
        }
      }
      prices {
        price {
          currency
          value
        }
        row_total {
          value
        }
        total_item_discount {
          value
        }
      }
      quantity
      # eslint-disable-next-line @graphql-eslint/require-id-when-available
      ... on ConfigurableCartItem {
        # eslint-disable-next-line @graphql-eslint/require-id-when-available
        configurable_options {
          id
          configurable_product_option_uid
          option_label
          configurable_product_option_value_uid
          value_label
          value_id
          __typename
        }
      }
    }
  }
`;
